"use strict";

angular.module('app.shared.resize.RESIZE_CONFIG', [])
    .constant('RESIZE_CONFIG', {
        DEBOUNCE_MILLIS: 400,
        EVENT_NAME: 'resizeDirective::resize',
        TARGET_SIZES:  {
            xs: 0,
            sm: 768,
            md: 992,
            lg: 1200
        }
  });


// WEBPACK FOOTER //
// ./app.v2/components/shared/resize/resizeConfig.js